import { put } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import { z } from "zod";

interface UpdateBillingSpecialistParams {
  workplaceId: string;
  userId: string;
}

const updateBillingSpecialistRequestSchema = z.object({
  userId: z.string(),
});

const updateBillingSpecialistResponseSchema = z.object({
  billingSpecialist: z.string(),
  userId: z.string(),
});

type UpdateBillingSpecialistResponse = z.infer<typeof updateBillingSpecialistResponseSchema>;

export function useUpdateBillingSpecialist(
  options: UseMutationOptions<
    UpdateBillingSpecialistResponse,
    unknown,
    UpdateBillingSpecialistParams
  > = {}
) {
  return useMutation({
    mutationFn: async ({ workplaceId, userId }) => {
      const response = await put({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/billingSpecialist/${workplaceId}`,
        data: { userId },
        requestSchema: updateBillingSpecialistRequestSchema,
        responseSchema: updateBillingSpecialistResponseSchema,
      });
      return response.data;
    },
    ...options,
  });
}
